import React from 'react';
import { Box, Typography, Container } from '@mui/material';
import { Favorite as FavoriteIcon} from '@mui/icons-material';

const Footer = () => {
  return (
    <Box 
      component="footer" 
      sx={{ 
        py: 3, 
        mt: 'auto',
        bottom: 0,
        position: 'fixed',
        width: '-webkit-fill-available', 
      }}>
      <Container maxWidth="lg">
        <Typography variant="body2" color="textSecondary" align="center">
          © {new Date().getFullYear()}, Hecho con <FavoriteIcon color='error' fontSize='small' /> por <a href="https://www.tigabytes.com/" className="font-weight-bold" target="_blank" rel="noreferrer">Tigabytes</a>.
        </Typography>
      </Container>
    </Box>
  );
};

export default Footer;
